// extracted by mini-css-extract-plugin
export default {"error":"error_error__w7lJ3","error__conent":"error_error__conent__3LcKD"};